import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { CustomDatePicker } from '../ui/custom-date-picker';
import { getTodayString } from '../../utils/dateUtils';

export const FilterDialog = ({ 
  open, 
  onOpenChange, 
  filters, 
  setFilters, 
  onApply, 
  onClear 
}) => {
  const today = getTodayString();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[95vw] sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">Filter Silica Loads</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div className="space-y-2">
            <Label className="text-sm font-semibold">Client Name</Label>
            <Select value={filters.clientName || 'all'} onValueChange={(v) => setFilters(f => ({ ...f, clientName: v === 'all' ? '' : v }))}>
              <SelectTrigger className="h-11 rounded-xl"><SelectValue placeholder="All Clients" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All Clients</SelectItem>
                <SelectItem value="BALAJI CASTINGS PVT LTD">BALAJI CASTINGS PVT LTD</SelectItem>
                <SelectItem value="SVE CASTINGS PVT LTD">SVE CASTINGS PVT LTD</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label className="text-sm font-semibold">Date From</Label>
            <CustomDatePicker
              value={filters.dateFrom}
              onChange={(date) => setFilters(f => ({ ...f, dateFrom: date || '' }))}
              placeholder="Select start date"
              max={filters.dateTo || today}
              allowFuture={true}
            />
          </div>
          <div className="space-y-2">
            <Label className="text-sm font-semibold">Date To</Label>
            <CustomDatePicker
              value={filters.dateTo}
              onChange={(date) => setFilters(f => ({ ...f, dateTo: date || '' }))}
              placeholder="Select end date"
              min={filters.dateFrom || undefined}
              allowFuture={true}
            />
          </div>
          <div className="space-y-2">
            <Label className="text-sm font-semibold">Acceptance Status</Label>
            <Select value={filters.acceptanceStatus || 'all'} onValueChange={(v) => setFilters(f => ({ ...f, acceptanceStatus: v === 'all' ? '' : v }))}>
              <SelectTrigger className="h-11 rounded-xl"><SelectValue placeholder="All Status" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All Status</SelectItem>
                <SelectItem value="pending">Pending</SelectItem>
                <SelectItem value="accepted">Accepted</SelectItem>
                <SelectItem value="rejected">Rejected</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label className="text-sm font-semibold">Bill Status</Label>
            <Select value={filters.billStatus || 'all'} onValueChange={(v) => setFilters(f => ({ ...f, billStatus: v === 'all' ? '' : v }))}>
              <SelectTrigger className="h-11 rounded-xl"><SelectValue placeholder="All Status" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All Status</SelectItem>
                <SelectItem value="pending">Pending</SelectItem>
                <SelectItem value="paid">Paid</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="flex gap-3 pt-4">
            <Button type="button" variant="outline" onClick={onClear} className="flex-1 rounded-xl">
              Clear
            </Button>
            <Button type="button" onClick={onApply} className="flex-1 rounded-xl bg-slate-800 hover:bg-slate-700 text-white">
              Apply Filter
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
